const DEFAULT_AUTH_URL = 'http://localhost:8787';

export const AUTH_URL: string =
  (import.meta.env.VITE_AUTH_URL as string | undefined) ?? DEFAULT_AUTH_URL;
